import {ControlledMenu, MenuItem, useMenuState} from "@szhsin/react-menu";
import {useEffect, useState} from "react";
import {useAuth} from "../../providers/authprovider";
import {Button, Col, Row, Table, Dropdown, DropdownButton } from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faSpinner} from "@fortawesome/free-solid-svg-icons";
import {useNavigate, useParams} from "react-router-dom";
import useAlert from "../../components/CustomAlert";
import React from "react";
import Loading from "../../components/LoadingInfo";



export default function OffersTable({ handleEdit, privilege, handleRemove, offerTemplates, handleCreateFromTemplate}){

    const {buildingId} = useParams();
    const navigate = useNavigate();
    const {alert, showAlert} = useAlert();
    const { offers:{download,remove, getBuildingOffers}, viewPdf} = useAuth();
    const [menuProps, toggleMenu] = useMenuState();
    const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });
    const [currentContextOffer, setCurrentContextOffer] = useState(undefined);
    const [downloadingId, setDownloadingId] = useState(undefined)
    const [offers, setOffers] = useState(undefined)

    useEffect(()=>{
        if(offers !== undefined) return;

        getBuildingOffers(buildingId, ({success, error, content})=>{
            if(!success)
                return showAlert(error)
            setOffers(content);
        })
    })

    if(!offers) return <Loading />;

    const navigateBack = ()=>{navigate(-1)}

    function handleDownloadPdf(event, id){
        event.stopPropagation()

        setDownloadingId(id)

        download(id, (response)=>{
            let offer = offers.find(offer=>offer.id === id);
            let fileName = `${offer.nr}_${offer.name}.pdf`
            if(response.success)
                viewPdf(response.content);

            setDownloadingId(undefined)
        })
    }

    function handleEditOffer(){
        if(handleEdit && currentContextOffer)
            handleEdit(currentContextOffer);
    }

    function handleCopyOffer(){
        if(handleEdit && currentContextOffer)
            handleEdit(currentContextOffer, true)
    }

    
    const handleCreateNewOffer = (offerType)=>{
        navigate(`/offers/create/${offerType}`);
    }

    function handleDeleteOffer(){
        if(!currentContextOffer) return;

        remove(currentContextOffer.id, ({success, error, content})=>{
            if(!success)
                return showAlert(error)

            setOffers(prevOffers=>{
                const index = prevOffers.findIndex(po=>po.id === content.id);

                if(index < 0) return prevOffers;

                prevOffers.splice(index, 1);

                handleRemove(content)

                return [...prevOffers];
            })
        })
    }

    function handleOfferContextMenu(e, offer){
        e.preventDefault();
        setAnchorPoint({ x: e.clientX, y: e.clientY });
        toggleMenu(true);
        setCurrentContextOffer(offer)
    }

    function calculateOfferTotalPrice(offer){

        const priceListTable = findByType(offer.elements, 'table_price_list')
        if(priceListTable)
            return priceListTable.total;

        const table = offer.type === 'offer_simple'
            ? findByType(offer.elements, 'table_offer')
            : findByName(offer.elements, 'table_assortments')

        if(table.total){
            return table.total;
        }

        if(!table) return Number(0).toFixed(2)

        const {value} = table;

        return value.reduce((acc, row)=>{
            return acc + Number(row[1].value)
        }, 0).toFixed(2)
    }

    return (
        <>
            {alert()}
            <Row>
                <Col>
                    <Button variant={"outline-secondary"} className="m-3 me-4 float-start" onClick={navigateBack} ><FontAwesomeIcon icon={faArrowLeft} /> Powrót</Button>
                </Col>
                <Col>
                    {
                        privilege.edit && 
                        <DropdownButton
                                                className=" mb-3 me-4 float-end"
                                                    title="Nowa oferta"
                                                    id="bg-vertical-dropdown-3"
                                                >
                                                    <Dropdown.Item eventKey="1" onClick={()=>handleCreateNewOffer("offer_aeration")}>Napowietrzanie</Dropdown.Item>
                                                    <Dropdown.Item eventKey="2" onClick={()=>handleCreateNewOffer("offer_smoke_removal")}>Oddymianie</Dropdown.Item>
                                                    <Dropdown.Item eventKey="3" onClick={()=>handleCreateNewOffer("offer_simple")}>Prosta</Dropdown.Item>
                                                    <Dropdown.Divider />
                                                    <Dropdown.Header>Szablony</Dropdown.Header>
                                                    {
                                                        offerTemplates && offerTemplates.length > 0
                                                            ? offerTemplates.map(template =>
                                                                <Dropdown.Item key={template.id} onClick={()=>handleCreateFromTemplate(template.id)}>{template.name}</Dropdown.Item>
                                                            )
                                                            : <Dropdown.Item disabled>Brak szablonów</Dropdown.Item>
                                                    }
                                                </DropdownButton>
                    }
                </Col>
            </Row>
            {
                privilege.edit &&
                <ControlledMenu {...menuProps} anchorPoint={anchorPoint}
                                onClose={() => toggleMenu(false)}>
                    <MenuItem onClick={handleEditOffer}>Edytuj</MenuItem>
                    <MenuItem onClick={handleCopyOffer}>Kopiuj</MenuItem>
                    <MenuItem onClick={handleDeleteOffer}>Usuń</MenuItem>
                </ControlledMenu>
            }

            <Table  size={"sm"} striped bordered hover>
                <thead>
                <tr>
                    <th>L.p</th>
                    <th>Numer</th>
                    <th>Nazwa</th>
                    <th>Kontrahent</th>
                    <th>Wystawiający</th>
                    <th>Data oferty</th>
                    <th>Suma</th>
                    <td>Podgląd</td>
                </tr>
                </thead>
                <tbody>
                {
                    offers.map((offer, lp)=>
                        <tr key={offer.id} onClick={(e)=>handleOfferContextMenu(e,offer)}>
                            <td>{lp+1}</td>
                            <td>{offer.nr}</td>
                            <td>{offer.name}</td>
                            <td>{offer.client.name}</td>
                            <td>{offer.user}</td>
                            <td>{offer.date}</td>
                            <td>{calculateOfferTotalPrice(offer)}</td>
                            <td>
                                {  downloadingId === offer.id ?
                                    <Button variant={"secondary"} ><FontAwesomeIcon icon={faSpinner} spin={true} /></Button>
                                    :
                                    <Button variant={"secondary"} onClick={(e)=>handleDownloadPdf(e, offer.id)}>PDF</Button>
                                }

                            </td>
                        </tr>
                    )
                }
                </tbody>
            </Table>
        </>

    )
}

function findByName(elements, name){
    for(let element of elements){
        if(element.name === name)
            return element;

        if(Array.isArray(element.children)){
            const found = findByName(element.children, name)
            if(found)
                return found
        }

    }
    return false;
}

function findByType(elements, type){
    for(let element of elements){
        if(element.type === type)
            return element;

        if(Array.isArray(element.children)){
            const found = findByType(element.children, type)
            if(found)
                return found
        }

    }
    return false;
}
